export default "__VITE_PUBLIC_ASSET__54f88631__"